module.exports = __webpack_public_path__ + "img/ywAward-4.d2479a65.png";